import React, { FunctionComponent, useRef, useState } from "react";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddContacts/AddContacts.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import { v4 as uuidv4 } from 'uuid';
import { createCouponCost } from "../../Services/resources";
import InputTextDate from "../../Components/TextInput/InputTextDate";
import { Grid, Button, useMediaQuery, useTheme, Box } from "@mui/material";
import TextInput from '../../Components/TextInput/InputText';
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import "../../theme-vars.css";

type Props = {
  history: any;
  theme: any;
};

const AddCoupon: FunctionComponent<Props> = ({ history, theme }) => {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const [load, setLoad] = useState(false);
  const [couponCode, setCouponCode] = useState<string>("");
  const [discount, setDiscount] = useState<number | undefined | any>(undefined);
  const dispatcher = useDispatch();

  const handleValidation = () => {
    if (!couponCode.trim()) {
      dispatcher(showSnackbarAction("Please enter a coupon code!", "error"));
      return false;
    }
    if (!discount || discount <= 0 || discount > 100) {
      dispatcher(
        showSnackbarAction(
          "Please enter a valid discount percentage (1-100)!",
          "error"
        )
      );
      return false;
    }
    // if (!expirationDate) {
    //   dispatcher(
    //     showSnackbarAction("Please select an expiration date!", "error")
    //   );
    //   return false;
    // }
    return true;
  };

  const createCoupon = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!handleValidation()) return;
    try {
      const coupon_id = uuidv4();
      setLoad(true);
      createCouponCost(
        couponCode.trim(),
        discount,
        // expirationDate,
        coupon_id,
        dispatcher,
        (data: boolean) => setLoad(data),
        history
      );
    } catch (error) {
      console.error("Error creating coupon:", error);
      dispatcher(
        showSnackbarAction(
          "Failed to create coupon. Please try again.",
          "error"
        )
      );
    } finally {
      setLoad(false);
    }
  };

  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  return (
    <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load && <Loading />}
      {isMobile && (
        <div className="d-flex flex-row w-100 px-4 pt-2">
          <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Create Coupon</h5>
        </div>
      )}
      <div
        className="w-100 d-flex flex-column gap-2 px-4"
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: isMobile ? 'auto' : undefined,
          maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
        }}
      >
        <form
          className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '16px' : '32px',
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: isMobile ? '50px' : 0,
          }}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={6}>
              <InputTextDate
                type="text"
                title="coupon code"
                value={couponCode}
                onChange={(e: any) => setCouponCode(e.target.value)}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputTextDate
                type="number"
                title="Discount (%)"
                value={discount}
                onChange={(e: any) => setDiscount(Number(e.target.value))}
                required={true}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: 12 }}>
              <StyledSubmitButton
                onClick={(e) => createCoupon(e)}
                themeMode={themeMUI.palette.mode}
              >
                {load ? (
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    <Circles color="#fff" height={20} width={20} />
                  </span>
                ) : (
                  <>Submit</>
                )}
              </StyledSubmitButton>
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
  };
};

export default connect(mapStateToProps)(AddCoupon);
